/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Formik, useFormikContext } from 'formik';
import { openSnackbar } from 'store/slices/snackbar';
import { useNavigate, useLocation } from 'react-router-dom';
import { findKeyInObject } from 'utils/findKeyInObjects';
import { ListingActions } from 'store/slices/listings';
import { TermsActions } from 'store/slices/Terms&Condition';
import { Stack, Button, Grid, Tabs, Tab, Box, Typography, LinearProgress } from '@mui/material';
import { gridSpacing, roles } from 'store/constant';
import AnimateButton from 'ui-component/extended/AnimateButton';
import { LoadingButton } from '@mui/lab';
import useAuth from 'hooks/useAuth';
import Listing from '../Listing/Listing';
import General from '../Listing/General';
import AdditionalInfo from '../Listing/Additional';
import RoomsInfo from '../Listing/Rooms';
import DocumentsInfo from '../Listing/Documents';
import ShowingInformation from '../Listing/Showing';
import { formatDate, transformValues } from '../Listing/HelperFunction';
import { complexSpecific, complexSpecificDuplicate, defaultValues, reverseMap, unitSpecific, validationSchema } from './validation';
import TermModal from './TermModal';
import HowToApply from '../Listing/HowToApply';
import FormError from '../Listing/Form_error';
import { EmployeeActions } from 'store/slices/employees';
import { openConfirmationModal } from 'store/slices/confirmationModal';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

import MainCard from './MainCard';
import Breadcrumbs from 'ui-component/extended/Breadcrumbs';
import GreenEnergy from '../Listing/GreenEnergy';
import ImageUploadComponent from './Details/PhotosData';
import AgentOfficeInformation from '../Listing/Agent';
import Remarks from '../Listing/Remarks';

const AutoSave = ({ handleSave, progress, alreadySaved }) => {
    const { values, setErrors, setTouched, setStatus, setSubmitting } = useFormikContext();

    const valuesRef = useRef(values);
    const progressRef = useRef(progress);
    const savedRef = useRef(alreadySaved);
    const dispatch = useDispatch();

    useEffect(() => {
        valuesRef.current = values;
    }, [values]);

    useEffect(() => {
        progressRef.current = progress;
    }, [progress]);

    useEffect(() => {
        savedRef.current = alreadySaved;
    }, [alreadySaved]);

    useEffect(() => {
        const handleBeforeUnload = (event) => {
            if (!savedRef.current) {
                event.preventDefault();
                event.returnValue = '';
                handleSave(valuesRef.current, setErrors, setTouched, setStatus, setSubmitting, false, progressRef.current);
            }
        };

        window.addEventListener('beforeunload', handleBeforeUnload);

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload);

            if (!savedRef.current) {
                dispatch(
                    openConfirmationModal({
                        open: true,
                        message: 'Click on the submit button to save the form',
                        handleConfirm: async () => {
                            handleSave(valuesRef.current, setErrors, setTouched, setStatus, setSubmitting, false, progressRef.current);
                        }
                    })
                );
            }
        };
    }, []);

    return null;
};

const CreateListingNew = () => {
    const [tabLabels, setTabLabels] = useState([
        { name: 'Listing Details', time: '( 5 min. Appx )' },
        { name: 'General Info.', time: '( 10 min. Appx )' },
        { name: 'Property Details', time: '( 4 min. Appx )' },
        { name: 'Property Overview', time: '( 5 min. Appx )' },
        { name: 'Essential Information', time: '( 12 min. Appx )' },
        { name: 'Occupant & Management', time: '( 10 min. Appx )' },
        { name: 'Property Insights', time: '( 8 min. Appx )' }
    ]);

    const [open, setOpen] = useState(false);
    const [reqSend, setReqSend] = useState(false);
    const [isValidateClicked, setIsValidateClicked] = useState(false);
    const [isDataSaved, setIsDataSaved] = useState(true);

    const [propertyContacts, setPropertyContacts] = useState({ primary: [], secondary: [] });

    const [shareAccessList, setShareAccessList] = useState([]);

    // getting form value from local
    const [savedValues, setSavedValues] = useState({});

    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);

    const { role, user } = useAuth();

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const {
        createListings,
        editListings,
        fetchListingDetails,
        fetchListingsAccessess,
        deleteRoomListings,
        deleteGreenEnergyBuildingListings
    } = ListingActions;

    const { singleListing } = useSelector((state) => state.listings);

    const [selectedTab, setSelectedTab] = useState(0);
    const [myProgress, setMyProgress] = useState(0);

    // for tos
    const { terms } = useSelector((state) => state.Terms);
    const { fetchAllTerms } = TermsActions;
    const { fetchEmployeeContacts } = EmployeeActions;

    // Total Required Fields
    const totalRequiredFields = 93;
    const totalAdminRequiredFields = 109;

    const location = useLocation();

    // Helper function to get query parameters
    const getQueryParams = (search) => new URLSearchParams(search);

    const handleTabChange = (_, newValue) => {
        setSelectedTab(newValue);
    };

    const url = window.location.pathname;
    const id = url.substring(url.lastIndexOf('/') + 1);

    const queryParams = getQueryParams(location.search);
    const isDuplicate = queryParams.get('duplicate') === 'YES';
    const isComplexSpecifc = queryParams.get('complexSpecific') === 'YES';
    const isUnitSpecifc = queryParams.get('unitSpecific') === 'YES';

    useEffect(() => {
        // Set the Progress Value
        setMyProgress(singleListing?.completion || 0);
    }, [singleListing, id]);

    // useEffect(() => {
    //     const user_id = user?.id;
    //     let localStorageName = user_id + '_formValues';
    //     if (id !== 'add') {
    //         localStorageName = user_id + '_formValues' + '_e' + id;
    //     }

    //     setSavedValues(JSON.parse(localStorage.getItem(localStorageName)) || {});
    // }, [id]);

    useEffect(() => {
        setTabLabels([
            { name: 'Listing Details', time: '( 5 min. Appx )' },
            { name: 'General Info.', time: '( 10 min. Appx )' },
            { name: 'Property Details', time: '( 4 min. Appx )' },
            { name: 'Property Overview', time: '( 5 min. Appx )' },
            { name: 'Essential Information', time: '( 12 min. Appx )' },
            { name: 'Occupant & Management', time: '( 10 min. Appx )' },
            { name: 'Property Insights', time: '( 8 min. Appx )' }
        ]);
    }, [id]);

    useEffect(() => {
        dispatch(fetchAllTerms());
        // if (rmSelected?.length > 0) {
        //     dispatch(fetchEmployeeContacts({ search: '', rm: rmSelected })).then((data) => {
        //         setPropertyContacts({
        //             ...propertyContacts,
        //             primary: data?.payload?.primaryData
        //         });
        //     });
        // } else {
        //     dispatch(fetchEmployeeContacts({ search: '' })).then((data) => {
        //         setPropertyContacts({
        //             primary: data?.payload?.primaryData,
        //             secondary: data?.payload?.secondaryData
        //         });
        //     });
        // }
        dispatch(fetchEmployeeContacts({ search: '' })).then((data) => {
            setPropertyContacts({
                primary: data?.payload?.primaryData,
                secondary: data?.payload?.secondaryData
            });
        });
    }, []);

    useEffect(() => {
        dispatch(fetchListingDetails(id));

        if (id !== 'add') {
            dispatch(fetchListingsAccessess(id)).then((e) => {
                setShareAccessList(e?.payload?.map((e) => e?.user_id));
            });
        }
    }, [id]);

    const getButtonLabel = (selectedTab, id) => {
        // if (selectedTab < 9) {
        //     return 'Validate';
        // }
        // if (isDuplicate) {
        //     return 'Save Duplicate';
        // }
        // if (selectedTab < 10 && id !== 'add') {
        //     return 'Validate';
        // }
        // if (id !== 'add') {
        //     return 'Edit Property';
        // }
        // return 'Add Property';

        if (selectedTab < 6) {
            return 'Validate Form';
        }
        if (selectedTab < 6 && id !== 'add') {
            return 'Validate Form';
        }

        return 'Save & Submit Listing';
    };

    const handleSave = async (values, setErrors, setTouched, setStatus, setSubmitting, isSubmit = false, progressValue = null) => {
        // const user_id = user?.id;
        // let localStorageName = user_id + '_formValues';
        // if (id !== 'add') {
        //     localStorageName = user_id + '_formValues' + '_e' + id;
        // }
        // localStorage.setItem(localStorageName, JSON.stringify(values));
        if (!isSubmit) {
            setIsValidateClicked((prev) => false);
            setErrors({});
        }

        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
        console.log(selectedTab, values?.complexName);

        if (selectedTab === 0 && values?.complexName === '') {
            dispatch(
                openSnackbar({
                    open: true,
                    message: 'Please select a complex',
                    variant: 'alert',
                    alert: {
                        color: 'error'
                    },
                    close: true
                })
            );
        }

        if (isSubmit) {
            // Manually Trigger Errors
            validationSchema(role)
                .validate(values, { abortEarly: false })
                .then((validData) => {
                    // Clear errors if the data is valid

                    setErrors({});
                    setTouched({});
                    setIsValidateClicked((prev) => false);
                    if (Object.keys(terms).length > 0 && !terms?.userAgreement && !reqSend) {
                        handleOpen();
                        return;
                    }
                })
                .catch((validationErrors) => {
                    // Convert Yup validation errors to Formik's error format
                    const errors = validationErrors.inner.reduce((acc, err) => {
                        acc[err.path] = err.message;
                        return acc;
                    }, {});

                    const touched = validationErrors.inner.reduce((acc, err) => {
                        acc[err.path] = true;
                        return acc;
                    }, {});

                    setErrors(errors);
                    setTouched(touched);
                    setIsValidateClicked((prev) => true);
                });

            if (Object.keys(terms).length > 0 && !terms?.userAgreement && !reqSend && myProgress === 100) {
                handleOpen();
                return;
            }
        }

        // if (!(id === 'add' || isDuplicate) && selectedTab >= 9 && selectedTab < 10) {
        //     setSelectedTab(selectedTab + 1);
        // } else if (selectedTab < 9) {
        //     setSelectedTab(selectedTab + 1);
        // }


        if (selectedTab <= 6 && !(id === 'add' || isDuplicate)) {
            setSelectedTab(selectedTab + 1);
        }

        try {
            const newFields = transformValues(values, progressValue || myProgress);

            let res;

            // if (Object.keys(terms).length > 0 && !terms?.userAgreement && !reqSend) {
            //     handleOpen();
            //     return;
            // } else
            if (id === 'add') {
                res = await dispatch(createListings(newFields));
            } else if (isDuplicate) {
                // Duplicate the Data and create new
                res = await dispatch(createListings(newFields));
            } else {
                const isAdmin = role === 'ADMIN';

                const newValues = {
                    ...newFields,
                    ...(isAdmin ? {} : { listingStatus: myProgress >= 99 && isSubmit ? 'PENDING' : 'NONE' })
                };

                res = await dispatch(
                    editListings({
                        values: newValues,
                        id
                    })
                );
            }

            if (res?.payload?.status === 200 || res?.payload?.status === 201) {
                dispatch(
                    openSnackbar({
                        open: true,
                        message: isSubmit ? `Listing Saved` : `Saved`,
                        variant: 'alert',
                        alert: {
                            color: 'success'
                        },
                        close: true
                    })
                );

                setIsDataSaved(true);

                // if (isSubmit) {
                //     setTimeout(() => {
                //         setStatus({ success: true });
                //         setSubmitting(false);
                //         navigate('/listing/manage-listing');
                //     }, 500);
                // }
            } else {
                dispatch(
                    openSnackbar({
                        open: true,
                        message:
                            findKeyInObject(res?.payload, `message`) ||
                            findKeyInObject(res?.payload, `error`) ||
                            `Oops! Something went wrong.`,
                        variant: 'alert',
                        alert: {
                            color: 'error'
                        },
                        close: true
                    })
                );
            }
        } catch (err) {
            setStatus({ success: false });
            setErrors({ submit: 'Invalid credentials' });
            setSubmitting(false);
        }
    };

    // DEV
    const initialValues = {
        regionalAccess:
            shareAccessList?.filter((e) => {
                return propertyContacts?.secondary?.some((usr) => usr?.id === e);
            }) ||
            savedValues?.regionalAccess ||
            [],
        apartmentAccess:
            shareAccessList?.filter((e) => {
                return propertyContacts?.primary?.some((usr) => usr?.id === e);
            }) ||
            savedValues?.apartmentAccess ||
            [],

        listingId: savedValues?.listingId || '',
        listingAgreement:
            singleListing?.listingInformation?.listingAgreement || savedValues?.listingAgreement || 'Exclusive Right To Lease',
        listingAgreementDoc: singleListing?.listingInformation?.listingAgreementDoc || savedValues?.listingAgreementDoc || '',
        // listingService: singleListing?.listingInformation?.listingService || '',
        listPrice: singleListing?.listingInformation?.listPrice || savedValues?.listPrice || '',
        housingVouchers: singleListing?.listingInformation?.housingVouchers || savedValues?.housingVouchers || '',
        expirationDate: formatDate(singleListing?.listingInformation?.expirationDate) || formatDate(savedValues?.expirationDate) || null,
        // auctionDate: formatDate(singleListing?.listingInformation?.auctionDate) || '',
        // specialListingConditions: singleListing?.listingInformation?.specialListingConditions || [],

        // Location Information
        streetNumber: singleListing?.locationInformation?.streetNumber || savedValues?.streetNumber || '',
        streetDirPrefix: singleListing?.locationInformation?.streetDirPrefix || savedValues?.streetDirPrefix || '',
        streetDirSuffix: singleListing?.locationInformation?.streetDirSuffix || savedValues?.streetDirSuffix || '',
        // outOfStateCounty: singleListing?.locationInformation?.outOfStateCounty || savedValues?.outOfStateCounty || '',
        // OutOfStateCity: singleListing?.locationInformation?.outOfStateCity || savedValues?.OutOfStateCity || '',
        unitNumber: singleListing?.locationInformation?.unit || savedValues?.unitNumber || '',
        taxLot: singleListing?.locationInformation?.taxLot || savedValues?.taxLot || '',
        taxBlock: singleListing?.locationInformation?.taxBlock || savedValues?.taxBlock || '',
        // additionalParcelDesc: singleListing?.locationInformation?.additionalParcelDesc || '',
        latitude: singleListing?.locationInformation?.latitude || savedValues?.latitude || '',
        longitude: singleListing?.locationInformation?.longitude || savedValues?.longitude || '',
        streetName: singleListing?.locationInformation?.streetName || savedValues?.streetName || '',
        streetTypeOrSuffix: singleListing?.locationInformation?.streetTypeOrSuffix || savedValues?.streetTypeOrSuffix || '',
        county: singleListing?.locationInformation?.county || savedValues?.county || '',
        country: singleListing?.locationInformation?.country || savedValues?.country || '',
        city: singleListing?.locationInformation?.city || savedValues?.city || '',
        state: singleListing?.locationInformation?.state || savedValues?.state || '',
        zipCode: singleListing?.locationInformation?.zipCode || savedValues?.zipCode || '',
        // postalCode: singleListing?.locationInformation?.postalCode || '',
        Subdivision: singleListing?.locationInformation?.subdivision || '',
        taxLegalDescription: singleListing?.locationInformation?.taxLegalDescription || savedValues?.taxLegalDescription || '',
        parcelNumber: singleListing?.locationInformation?.parcelNumber || savedValues?.parcelNumber || '',
        // addionalParecel: singleListing?.locationInformation?.additionalParcels || '',
        mlsArea: singleListing?.locationInformation?.mlsArea || savedValues?.mlsArea || '',
        etj: singleListing?.locationInformation?.etj || savedValues?.etj || '',
        femaFloodPlain: singleListing?.locationInformation?.femaFloodPlain || savedValues?.femaFloodPlain || [],

        // School Information
        outOfStateSchoolDistrict: singleListing?.schoolInformation?.outOfStateSchoolDistrict || savedValues?.outOfStateSchoolDistrict || '',
        elementaryOther: singleListing?.schoolInformation?.elementryOther || savedValues?.elementaryOther || '',
        middleJuniorOther: singleListing?.schoolInformation?.middleOrJuniorOther || savedValues?.middleJuniorOther || '',
        highSchoolOther: singleListing?.schoolInformation?.highSchoolOther || savedValues?.highSchoolOther || '',
        schoolDistrict: singleListing?.schoolInformation?.schoolDistrict || savedValues?.schoolDistrict || '',
        elementary: singleListing?.schoolInformation?.elementy || savedValues?.elementary || '',
        middleJunior: singleListing?.schoolInformation?.middleOrJunior || savedValues?.middleJunior || '',
        highSchool: singleListing?.schoolInformation?.highSchool || savedValues?.highSchool || '',

        // General Information
        alsoListedAs: singleListing?.generalInformation?.alsoListedAs || savedValues?.alsoListedAs || '',
        otherLevelBeds: singleListing?.generalInformation?.otherLevelBeds || savedValues?.otherLevelBeds || '',
        builderName: singleListing?.generalInformation?.builderName || savedValues?.builderName || '',
        distanceToWaterAccess: singleListing?.generalInformation?.distanceToWaterAccess || savedValues?.distanceToWaterAccess || '',
        waterBodyName: singleListing?.generalInformation?.waterBodyName || savedValues?.waterBodyName || '',
        mainLevelBedrooms: singleListing?.generalInformation?.mainLevelBedrooms || savedValues?.mainLevelBedrooms || '',
        yearBuilt: singleListing?.generalInformation?.yearBuilt || savedValues?.yearBuilt || '',
        bathroomsFull: singleListing?.generalInformation?.bathroomsFull || savedValues?.bathroomsFull || '',
        bathroomsHalf: singleListing?.generalInformation?.bathroomsHalf || savedValues?.bathroomsHalf || '',
        living: singleListing?.generalInformation?.living || savedValues?.living || '',
        dining: singleListing?.generalInformation?.dining || savedValues?.dining || '',
        livingArea: singleListing?.generalInformation?.livingArea || savedValues?.livingArea || '',
        garageSpaces: singleListing?.generalInformation?.garageSpaces || savedValues?.garageSpaces || '',
        parkingTotal: singleListing?.generalInformation?.parkingTotal || savedValues?.parkingTotal || '',
        parkingFeeFrom: singleListing?.generalInformation?.parkingFeeFrom || savedValues?.parkingFeeFrom || '',
        parkingFeeTo: singleListing?.generalInformation?.parkingFeeTo || savedValues?.parkingFeeTo || '',
        parkingFeeFrequency: singleListing?.generalInformation?.parkingFeeFrequency || savedValues?.parkingFeeFrequency || '',
        lotSizeAcres: singleListing?.generalInformation?.lotSizeAcres || savedValues?.lotSizeAcres || '',
        lotDimensions: singleListing?.generalInformation?.lotDimensions || savedValues?.lotDimensions || '',
        // yearBuiltSource: singleListing?.generalInformation?.yearBuiltSource || '',
        livingAreaSource: singleListing?.generalInformation?.livingAreaSource || savedValues?.livingAreaSource || '',
        // ownershipType: singleListing?.generalInformation?.ownershipType || '',
        directionFaces: singleListing?.generalInformation?.directionFaces || savedValues?.directionFaces || '',
        levels: singleListing?.generalInformation?.levels || savedValues?.levels || [],
        propertySubTypes: singleListing?.generalInformation?.propertySubType || savedValues?.propertySubTypes || '',
        propertyCondition: singleListing?.generalInformation?.propertyCondition || savedValues?.propertyCondition || [],
        constructionMaterials: singleListing?.generalInformation?.constructionMaterials || savedValues?.constructionMaterials || [],
        parkingFeatures: singleListing?.generalInformation?.parkingFeatures || savedValues?.parkingFeatures || [],
        foundationDetails: singleListing?.generalInformation?.foundationDetails || savedValues?.foundationDetails || [],
        roof: singleListing?.generalInformation?.roof || savedValues?.roof || [],
        view: singleListing?.generalInformation?.view || savedValues?.view || [],
        lotFeatures: singleListing?.generalInformation?.lotFeatures || savedValues?.lotFeatures || [],
        waterfrontFeatures: singleListing?.generalInformation?.waterfrontFeatures || savedValues?.waterfrontFeatures || [],
        flooring: singleListing?.generalInformation?.flooring || savedValues?.flooring || [],
        restrictions: singleListing?.generalInformation?.restrictions || savedValues?.restrictions || [],
        unitStyle: singleListing?.generalInformation?.unitStyle || savedValues?.unitStyle || [],
        complexName:
            user?.roleName === 'APARTMENT_MANAGER'
                ? singleListing?.generalInformation?.complexName || user?.complexName || savedValues?.complexName || ''
                : singleListing?.generalInformation?.complexName || '',
        complex_id:
            user?.roleName === 'APARTMENT_MANAGER'
                ? singleListing?.generalInformation?.complex_id || user?.complex_id || savedValues?.complex_id || '' : singleListing?.generalInformation?.complex_id || '',
        unitsInComplex: singleListing?.generalInformation?.unitsInComplex || savedValues?.unitsInComplex || '',
        floorPlanName: singleListing?.generalInformation?.floorPlanName || savedValues?.floorPlanName || '',
        smokingInside: singleListing?.generalInformation?.smokingInside || savedValues?.smokingInside || '',
        moveInSpecialYN: singleListing?.generalInformation?.moveInSpecial || savedValues?.moveInSpecialYN || '',
        moveInSpecialDescription:
            singleListing?.generalInformation?.moveInSpecialDescription || savedValues?.moveInSpecialDescription || '',

        // Additional Information
        communityWebSite: singleListing?.additionalInformation?.communityWebSite || savedValues?.communityWebSite || '',
        guestBeds: singleListing?.additionalInformation?.guestBeds || savedValues?.guestBeds || '',
        guestFullBaths: singleListing?.additionalInformation?.guestFullBaths || savedValues?.guestFullBaths || '',
        guestHalfBaths: singleListing?.additionalInformation?.guestHalfBaths || savedValues?.guestHalfBaths || '',
        fireplaces: singleListing?.additionalInformation?.fireplaces || savedValues?.fireplaces || '',
        interiorFeatures: singleListing?.additionalInformation?.interiorFeatures || savedValues?.interiorFeatures || [],
        exteriorFeatures: singleListing?.additionalInformation?.exteriorFeatures || savedValues?.exteriorFeatures || [],
        appliances: singleListing?.additionalInformation?.appliances || savedValues?.appliances || [],
        windowFeatures: singleListing?.additionalInformation?.windowFeatures || savedValues?.windowFeatures || [],
        securityFeatures: singleListing?.additionalInformation?.securityFeatures || savedValues?.securityFeatures || [],
        accessibilityFeatures: singleListing?.additionalInformation?.accessibilityFeatures || savedValues?.accessibilityFeatures || [],
        laundryLocation: singleListing?.additionalInformation?.laundryLocation || savedValues?.laundryLocation || [],
        patioAndPorchFeatures: singleListing?.additionalInformation?.patioAndPorchFeatures || savedValues?.patioAndPorchFeatures || [],
        horseAmenities: singleListing?.additionalInformation?.horseAmenities || savedValues?.horseAmenities || [],
        privatePoolFeatures: singleListing?.additionalInformation?.privatePoolFeatures || savedValues?.privatePoolFeatures || [],
        fencing: singleListing?.additionalInformation?.fencing || savedValues?.fencing || [],
        otherStructures: singleListing?.additionalInformation?.otherStructures || savedValues?.otherStructures || [],
        guestAccommodations: singleListing?.additionalInformation?.guestAccommodations || savedValues?.guestAccommodations || [],
        communityFeatures: singleListing?.additionalInformation?.communityFeatures || savedValues?.communityFeatures || [],
        distanceToUTShuttle: singleListing?.additionalInformation?.distanceToUtShuttle || savedValues?.distanceToUTShuttle || '',
        distanceToMetro: singleListing?.additionalInformation?.distanceToMetro || savedValues?.distanceToMetro || '',
        distanceToLightRail: singleListing?.additionalInformation?.distanceToLightRail || savedValues?.distanceToLightRail || '',
        spaFeatures: singleListing?.additionalInformation?.spaFeatures || savedValues?.spaFeatures || [],
        fireplaceFeatures: singleListing?.additionalInformation?.fireplaceFeatures || savedValues?.fireplaceFeatures || [],
        furnished: singleListing?.additionalInformation?.furnished || savedValues?.furnished || '',
        appliancesMaintained: singleListing?.additionalInformation?.appliancesMaintained || savedValues?.appliancesMaintained || [],

        // Rooms Properties
        rooms: (singleListing?.rooms?.length
            ? singleListing?.rooms
            : (savedValues?.rooms?.length > 0 &&
                  savedValues.rooms.map((room) => ({
                      roomType: room?.roomType,
                      roomLevel: room?.roomLevel,
                      roomFeatures: room?.roomFeatures,
                      roomDescription: room?.roomDescription
                  }))) || [
                  {
                      roomType: '',
                      roomLevel: '',
                      roomFeatures: [],
                      roomDescription: ''
                  }
              ]
        ).map((room) => {
            const { id, property_id, createdAt, updatedAt, ...rest } = room;
            if (!isDuplicate)
                return {
                    ...rest,
                    id
                };
            return rest;
        }),

        // Documents and Utilities
        // groundwaterConservDistrict: singleListing?.documentsAndUtilities?.groundwaterConservDistrict || '',
        disclosures: singleListing?.documentsAndUtilities?.disclosures || savedValues?.disclosures || [],
        documentsAvailable: singleListing?.documentsAndUtilities?.documentsAvailable || savedValues?.documentsAvailable || [],
        utilities: singleListing?.documentsAndUtilities?.utilities || savedValues?.utilities || [],
        heating: singleListing?.documentsAndUtilities?.heating || savedValues?.heating || [],
        cooling: singleListing?.documentsAndUtilities?.cooling || savedValues?.cooling || [],
        waterSource: singleListing?.documentsAndUtilities?.waterSource || savedValues?.waterSource || [],
        sewer: singleListing?.documentsAndUtilities?.sewer || savedValues?.sewer || [],
        ownerPays: singleListing?.documentsAndUtilities?.ownerPays || savedValues?.ownerPays || [],
        meterDescription: singleListing?.documentsAndUtilities?.meterDescription || savedValues?.meterDescription || [],
        tenantPays: singleListing?.documentsAndUtilities?.tenantPays || savedValues?.tenantPays || [],

        // Green Energy
        greenEnergyEfficient: singleListing?.greenEnergy?.greenEnergyEfficient || savedValues?.greenEnergyEfficient || [],
        greenSustainability: singleListing?.greenEnergy?.greenSustainability || savedValues?.greenSustainability || [],
        greenEnergyVerification: (singleListing?.greenEnergy?.greenEnergyBuildingVerifications.length
            ? singleListing?.greenEnergy?.greenEnergyBuildingVerifications
            : (savedValues?.greenEnergyVerification?.length > 0 &&
                  savedValues.greenEnergyVerification.map((ele) => ({
                      greenEnergyBuildingVerificationType: ele?.greenEnergyBuildingVerificationType,
                      verificationMetric: ele?.verificationMetric,
                      verificationStatus: ele?.verificationStatus,
                      verificationRating: ele?.verificationRating,
                      verificationYear: ele?.verificationYear
                  }))) || [
                  {
                      greenEnergyBuildingVerificationType: '',
                      verificationMetric: '',
                      verificationStatus: '',
                      verificationRating: '',
                      verificationYear: ''
                  }
              ]
        ).map((verification) => {
            const { id, greenEnergy_id, createdAt, updatedAt, ...rest } = verification;
            if (!isDuplicate)
                return {
                    ...rest,
                    id
                };
            return rest;
        }),

        // Financial Information
        // association: singleListing?.financial?.associationYN || '',
        // associationRequirement: singleListing?.financial?.associationRequirement || '',
        // associationFeesInclude: singleListing?.financial?.AssociationFeesInclude || [],
        // associationName: singleListing?.financial?.associationName || '',
        // associationFeeFrequency: singleListing?.financial?.associationFeeFrequency || '',
        // acceptableFinancing: singleListing?.financial?.acceptableFinancing || [],
        // hOAManagementCo: singleListing?.financial?.hoaManagementCo || '',
        // associationTransferFee: singleListing?.financial?.associationTransferFee || '',
        // estimatedTax: singleListing?.financial?.estimatedTax || '',
        // taxYear: singleListing?.financial?.taxYear || '',
        // taxAnnualAmount: singleListing?.financial?.taxAnnualAmount || '',
        // taxAssessedValue: singleListing?.financial?.taxAssessedValue || '',
        // taxRate: singleListing?.financial?.taxRate || '',
        // title: singleListing?.financial?.title || '',
        // preferredTitleCompany: singleListing?.financial?.preferredTitleCompany || '',
        // associationFee: singleListing?.financial?.associationFee || '',
        // specialAssessment: singleListing?.financial?.specialAssessment || '',
        // buyerIncentive: singleListing?.financial?.buyerIncentive || [],
        // taxExemptions: singleListing?.financial?.taxExemptions || [],
        // possession: singleListing?.financial?.possession || [],

        // How To Apply Information
        associationYN: singleListing?.howToApply?.associationYN || savedValues?.associationYN || '',
        applicationFee: singleListing?.howToApply?.applicationFee || savedValues?.applicationFee || '',
        applicationFeePerPerson: singleListing?.howToApply?.applicationFeePerPerson || savedValues?.applicationFeePerPerson || '',
        applicationFeePayableTo: singleListing?.howToApply?.applicationFeePayableTo || savedValues?.applicationFeePayableTo || '',
        managedBy: singleListing?.howToApply?.managedBy || savedValues?.managedBy || '',
        securityDeposit: singleListing?.howToApply?.securityDeposit || savedValues?.securityDeposit || '',
        securityDepositPayableTo: singleListing?.howToApply?.securityDepositPayableTo || savedValues?.securityDepositPayableTo || '',
        administrationFee: singleListing?.howToApply?.administrationFee || savedValues?.administrationFee || '',
        administrationFeePayableTo: singleListing?.howToApply?.administrationFeePayableTo || savedValues?.administrationFeePayableTo || '',
        firstMonthRentPayableTo: singleListing?.howToApply?.firstMonthRentPayableTo || savedValues?.firstMonthRentPayableTo || '',
        shortTermPremium: singleListing?.howToApply?.shortTermPremium || savedValues?.shortTermPremium || '',
        shortTermPremiumAmount: singleListing?.howToApply?.shortTermPremiumAmount || savedValues?.shortTermPremiumAmount || '',
        onSiteCompliance: singleListing?.howToApply?.onSiteCompliance || savedValues?.onSiteCompliance || '',
        renterInsuranceRequired: singleListing?.howToApply?.renterInsuranceRquired || savedValues?.renterInsuranceRequired || '',
        minimumLeaseMonths: singleListing?.howToApply?.minimumLeaveMonths || savedValues?.minimumLeaseMonths || '',
        maximumLeaseMonths: singleListing?.howToApply?.maximumLeaveMonths || savedValues?.maximumLeaseMonths || '',
        availableDate: formatDate(singleListing?.howToApply?.availableDate) || formatDate(savedValues?.availableDate) || null,
        certifiedFunds: singleListing?.howToApply?.certifiedFunds || savedValues?.certifiedFunds || '',
        leaseGuarantorYN: singleListing?.howToApply?.leaseGuarantorYN || savedValues?.leaseGuarantorYN || '',
        leaseTerm: singleListing?.howToApply?.leaseTerm || savedValues?.leaseTerm || '',
        applicationPolicy: singleListing?.howToApply?.applicationPolicy || savedValues?.applicationPolicy || '',
        petsAllowed: singleListing?.howToApply?.petAllowed || savedValues?.petsAllowed || [],
        petDeposit: singleListing?.howToApply?.petDeposit || savedValues?.petDeposit || '',
        maxNumberOfPets: singleListing?.howToApply?.maxNumberOfPets || savedValues?.petDeposit || '',
        petDepositPerPet: singleListing?.howToApply?.petDepositPerPet || savedValues?.petDepositPerPet || '',
        monthlyPetRent: singleListing?.howToApply?.monthlyPetRent || savedValues?.monthlyPetRent || '',
        monthlyPetRentPerPet: singleListing?.howToApply?.monthlyPetRentPerPet || savedValues?.monthlyPetRentPerPet || '',
        additionalPetFee: singleListing?.howToApply?.additionalPetFee || savedValues?.additionalPetFee || '',
        additionPetFeeDescription: singleListing?.howToApply?.additionalPetFeeDescription || savedValues?.additionPetFeeDescription || '',
        applicationRequired: singleListing?.howToApply?.applicationRequired || savedValues?.applicationRequired || [],
        oneTimeExpenses: singleListing?.howToApply?.oneTimeExpense || savedValues?.oneTimeExpenses || [],
        recurringExpenses: singleListing?.howToApply?.recurringExpense || savedValues?.recurringExpenses || [],
        applicationDeliverAddress: singleListing?.howToApply?.applicationDriverAddress || savedValues?.applicationDeliverAddress || '',
        websiteAppLinkPublicView: singleListing?.howToApply?.websiteAppLinkPublicView || savedValues?.websiteAppLinkPublicView || '',
        websiteAppLinkAgentView: singleListing?.howToApply?.websiteAppLinkAgentView || savedValues?.websiteAppLinkAgentView || '',
        sellerContributionsYN: singleListing?.howToApply?.sellerContributionYN || savedValues?.sellerContributionsYN || '',
        intermediaryYN: singleListing?.howToApply?.intermediary || savedValues?.intermediaryYN || 'NO',
        rentSpreeOnlineApplicationYN:
            singleListing?.howToApply?.rentSpreeOnlineApplicationYN || savedValues?.rentSpreeOnlineApplicationYN || '',
        commissionType: singleListing?.howToApply?.commissionType || savedValues?.commissionType || '',
        commission: singleListing?.howToApply?.commission || savedValues?.commission || '',

        // Showing Information
        accessCode: singleListing?.showingInformation?.accessCode || savedValues?.accessCode || '',
        showingContactName:
            singleListing?.showingInformation?.showingContactName ||
            savedValues?.showingContactName ||
            user?.firstName + ' ' + user?.lastName,
        showingContactPhone: singleListing?.showingInformation?.showingContactPhone || savedValues?.showingContactPhone || '',
        showingServicePhone: singleListing?.showingInformation?.showingServicePhone || savedValues?.showingServicePhone || '',
        showingInstructions: singleListing?.showingInformation?.showingInstructions || savedValues?.showingInstructions || '',
        occupantType: singleListing?.showingInformation?.occupantType || savedValues?.occupantType || 'Vacant',
        ownerName: singleListing?.showingInformation?.ownerName || savedValues?.ownerName || '',
        lockboxLocation: singleListing?.showingInformation?.lockboxLocation || savedValues?.lockboxLocation || '',
        lockboxType: singleListing?.showingInformation?.lockboxType || savedValues?.lockboxType || 'None',
        showingRequirements: singleListing?.showingInformation?.showingRequirements ||
            savedValues?.showingRequirements || [
                'Call First - Go',
                'Go',
                'Key with Management Company',
                'Key in Office',
                'Restricted Hours',
                'See Showing Instructions'
            ],
        showingContactType: singleListing?.showingInformation?.showingContactType ||
            savedValues?.showingContactType || ['Property Manager'],
        lockboxSerialNumber: singleListing?.showingInformation?.lockboxSerialNumber || savedValues?.lockboxSerialNumber || '',
        managementCompany:
            user?.roleName === 'APARTMENT_MANAGER'
                ? singleListing?.showingInformation?.managementCompany || user?.company?.name || savedValues?.managementCompany || ''
                : singleListing?.showingInformation?.managementCompany || '',
        managementCompanyPhone:
            user?.roleName === 'APARTMENT_MANAGER'
                ? singleListing?.showingInformation?.managementCompanyPhone ||
                  user?.company?.phoneNo ||
                  savedValues?.managementCompanyPhone ||
                  ''
                : singleListing?.showingInformation?.managementCompanyPhone || '',
        managementCompanyRep: singleListing?.showingInformation?.managementCompanyRep || savedValues?.managementCompanyRep || '',

        // agent information
        listAgentMLSID: singleListing?.agentInformation?.listAgentMLSID || savedValues?.listAgentMLSID || '',
        coListAgentMLSID: singleListing?.agentInformation?.coListAgentMLSID || savedValues?.coListAgentMLSID || '',

        // Compensation Information
        bonusToBA: singleListing?.compensationInformation?.bonustoBA || savedValues?.bonusToBA || '',
        bonusToBAAmount: singleListing?.compensationInformation?.bonustoBAAmount || savedValues?.bonusToBAAmount || '',
        subAgencyCompType: singleListing?.compensationInformation?.subAgencyCompensationType || savedValues?.subAgencyCompType || '',
        buyerAgencyCompType: singleListing?.compensationInformation?.buyerAgencyCompensationType || savedValues?.buyerAgencyCompType || '',
        subAgencyComp: singleListing?.compensationInformation?.subAgencyCompensation || savedValues?.subAgencyComp || '',
        buyerAgencyComp: singleListing?.compensationInformation?.buyerAgencyCompensation || savedValues?.buyerAgencyComp || '',
        dualVariableComp: singleListing?.compensationInformation?.dualVariableCompensation || savedValues?.dualVariableComp || '',
        intermediary: singleListing?.compensationInformation?.intermediary || savedValues?.intermediary || '',

        // attribution information
        listingOverride: singleListing?.attributionContact?.listingOverride || savedValues?.listingOverride || '',

        // Remarks Information
        privateRemarks: singleListing?.remarksInformation?.privateRemarks || savedValues?.privateRemarks || '',
        syndicationRemarks: singleListing?.remarksInformation?.syndicationRemarks || savedValues?.syndicationRemarks || '',
        directions: singleListing?.remarksInformation?.directions || savedValues?.directions || '',
        publicRemarks: singleListing?.remarksInformation?.publicRemarks || savedValues?.publicRemarks || '',

        // Virtual Tours
        brandedVirtualTourURL: singleListing?.virtualTours?.brandedVirtualTourUrl || savedValues?.brandedVirtualTourURL || '',
        unbrandedVirtualTourURL: singleListing?.virtualTours?.unbrandedVirtualTourUrl || savedValues?.unbrandedVirtualTourURL || '',
        brandedVideoTourURL: singleListing?.virtualTours?.brandedVideoTourUrl || savedValues?.brandedVideoTourURL || '',
        unbrandedVideoTourURL: singleListing?.virtualTours?.unbrandedVideoTourUrl || savedValues?.unbrandedVideoTourURL || '',
        listingDetailedURL: singleListing?.virtualTours?.listingDetailedUrl || savedValues?.listingDetailedURL || '',
        propertyPanorama: singleListing?.virtualTours?.createAPropertyPanoramaVirtualTour || savedValues?.propertyPanorama || '',

        // Internet Display
        internetListingDisplay: singleListing?.internetDisplay?.internetEntireListingDisplay || savedValues?.internetListingDisplay || '',
        internetAutomatedValuation:
            singleListing?.internetDisplay?.internetAutomatedValuationDisplay || savedValues?.internetAutomatedValuation || '',
        internetConsumerComment: singleListing?.internetDisplay?.internetConsumerComment || savedValues?.internetConsumerComment || '',
        internetAddressDisplay: singleListing?.internetDisplay?.internetAddressDisplay || savedValues?.internetAddressDisplay || '',
        listingWillAppearOn: singleListing?.internetDisplay?.listingWillAppearOn || savedValues?.listingWillAppearOn || []
    };

    const resetValues = (newList) => {
        const newObj = {};
        newList?.forEach((element) => {
            newObj[element] = initialValues[element];
        });

        return { ...defaultValues(user), ...newObj };
    };

    const getInitialValues = () => {
        // if (isComplexSpecifc) {
        //     return resetValues(complexSpecificDuplicate);
        // }
        if (isUnitSpecifc) {
            return resetValues(unitSpecific);
        }
        return initialValues;
    };

    const inputFocusRef = useRef(null);

    useEffect(() => {
        if (inputFocusRef.current) {
            inputFocusRef.current.focus();
            setTimeout(() => {
                inputFocusRef.current.blur(); // Unfocus (blur) the input
            }, 500);
        }
    }, [inputFocusRef]);

    return (
        <>
            <TermModal open={open} setOpen={setOpen} handleOpen={handleOpen} handleClose={handleClose} setReqSend={setReqSend} />

            {/* <Breadcrumbs
                heading={id !== 'add' ? (isDuplicate ? 'Duplicate Listing' : 'Add or Edit Listing') : 'Add Listing'}
                links={[
                    { name: 'Listings', href: '/listing/manage-listing' },
                    { name: id !== 'add' ? (isDuplicate ? 'Duplicate' : 'Add or Edit') : 'Add', href: '/' }
                ]}
            /> */}

            <Box
                // title={id !== 'add' ? (isDuplicate ? 'Duplicate Listing' : 'Add or Edit Listings') : 'Create New Listings'}
                element={
                    <Stack direction="row" gap={3} flexWrap="wrap" justifyContent="flex-end" alignItems="center">
                        <Button
                            aria-label="Edit Listing"
                            sx={{ p: 2 }}
                            onClick={() => {
                                navigate(`/listing/details/${id}`);
                            }}
                        >
                            View Details{'  '}
                            {/* <IconEye sx={{ py: 2 }} stroke={1.5} size="20px" /> */}
                        </Button>
                    </Stack>
                }
            >
                <Formik
                    enableReinitialize
                    initialValues={getInitialValues()}
                    validationSchema={validationSchema(role)}
                    onSubmit={async (values, { setErrors, setStatus, setSubmitting, setTouched }) => {
                        try {
                            if (selectedTab < 6) {
                                if (id === 'add' || isDuplicate) {
                                    handleSave(values, setErrors, setTouched, setStatus, setSubmitting);
                                    return;
                                }
                            }
                            if (!isDuplicate && selectedTab < 6 && id !== 'add') {
                                handleSave(values, setErrors, setTouched, setStatus, setSubmitting);
                                return;
                            }

                            const newFields = transformValues(values, myProgress);

                            let res;

                            if (Object.keys(terms).length > 0 && !terms?.userAgreement && !reqSend) {
                                handleOpen();
                                handleSave(values, setErrors, setTouched, setStatus, setSubmitting);
                                return;
                            } else if (id === 'add') {
                                res = await dispatch(createListings(newFields));
                            } else if (isDuplicate) {
                                // Duplicate the Data and create new
                                res = await dispatch(createListings(newFields));
                            } else {
                                const isAdmin = role === 'ADMIN';

                                const newValues = {
                                    ...newFields,
                                    ...(isAdmin ? {} : { listingStatus: 'PENDING' })
                                };

                                res = await dispatch(
                                    editListings({
                                        values: newValues,
                                        id
                                    })
                                );
                            }

                            if (res?.payload?.status === 200 || res?.payload?.status === 201) {
                                dispatch(
                                    openSnackbar({
                                        open: true,
                                        message: `Property ${id === 'add' ? 'created' : 'updated'} successfully`,
                                        variant: 'alert',
                                        alert: {
                                            color: 'success'
                                        },
                                        close: true
                                    })
                                );

                                setIsDataSaved(true);

                                setStatus({ success: true });
                                setSubmitting(false);
                                navigate('/listing/manage-listing');
                            } else {
                                dispatch(
                                    openSnackbar({
                                        open: true,
                                        message:
                                            findKeyInObject(res?.payload, `message`) ||
                                            findKeyInObject(res?.payload, `error`) ||
                                            `Oops! Something went wrong.`,
                                        variant: 'alert',
                                        alert: {
                                            color: 'error'
                                        },
                                        close: true
                                    })
                                );
                            }
                        } catch (err) {
                            // console.log({ err });
                            setStatus({ success: false });
                            setErrors({ submit: 'Invalid credentials' });
                            setSubmitting(false);
                        }
                    }}
                >
                    {({
                        errors,
                        handleSubmit,
                        handleChange,
                        handleBlur,
                        isSubmitting,
                        values,
                        touched,
                        setTouched,
                        setFieldValue,
                        setErrors,
                        setStatus,
                        setSubmitting
                    }) => {
                        const customHandleChange = (e) => {
                            handleChange(e);
                        };

                        const customHandleBlur = (e) => {
                            if (myProgress) {
                                setIsDataSaved(false);
                            }
                            handleBlur(e);
                        };

                        // Calculate the number of fields filled
                        let progress = 0;
                        const totalPendingErrors = Object.keys(errors).length;
                        // Calculate progress

                        // // console.log({ myProgress, totalPendingErrors, totalAdminRequiredFields, totalRequiredFields, progress, role });

                        if ((role === 'ADMIN' && totalPendingErrors) || (!totalPendingErrors && myProgress >= 98)) {
                            progress = ((totalAdminRequiredFields - totalPendingErrors) / totalAdminRequiredFields) * 100;
                        } else if (totalPendingErrors || (!totalPendingErrors && myProgress >= 98)) {
                            progress = ((totalRequiredFields - totalPendingErrors) / totalRequiredFields) * 100;
                        }
                        if (progress) {
                            setMyProgress(progress);
                        }

                        return (
                            <>
                                <AutoSave handleSave={handleSave} progress={myProgress} alreadySaved={isDataSaved} />

                                <Stack direction="row" justifyContent="flex-end" alignItems="center">
                                    <Button
                                        aria-label="Edit Listing"
                                        sx={{ p: 2, py: 0.5, m: 1 }}
                                        onClick={() => {
                                            navigate(`/listing/details/${id}`);
                                        }}
                                        variant="contained"
                                    >
                                        View Details
                                    </Button>
                                </Stack>

                                <Box sx={{ width: '100%', bgcolor: 'background.paper', mt: '10px' }}>
                                    <Tabs
                                        value={selectedTab}
                                        onChange={handleTabChange}
                                        variant="scrollable"
                                        scrollButtons="auto"
                                        aria-label="scrollable auto tabs example"
                                        TabIndicatorProps={{ style: { backgroundColor: 'black' } }}
                                        sx={{
                                            '& .MuiTabs-flexContainer': {
                                                paddingLeft: 0,
                                                marginLeft: 0,
                                                justifyContent: 'center'
                                            },
                                            '& .MuiTabs-indicator': {
                                                display: 'none'
                                            },
                                            '& .Mui-selected': {
                                                color: 'white !important',
                                                borderRadius: '3px !important'
                                            }
                                        }}
                                    >
                                        {tabLabels.map((label, index) => {
                                            // Determine if the tab should be marked with an error
                                            const hasError = Object.keys(errors).some((errorKey) => reverseMap[errorKey] === label.name);

                                            return (
                                                <Tab
                                                    key={index}
                                                    label={
                                                        <Box sx={{ textAlign: 'center' }}>
                                                            <Box
                                                                sx={{
                                                                    color:
                                                                        isValidateClicked && hasError
                                                                            ? 'white'
                                                                            : selectedTab === index
                                                                            ? 'white'
                                                                            : 'black'
                                                                }}
                                                            >
                                                                {label.name}
                                                            </Box>
                                                            <Box
                                                                sx={{
                                                                    mt: 1,
                                                                    fontSize: '12px',
                                                                    color:
                                                                        isValidateClicked && hasError
                                                                            ? 'white'
                                                                            : selectedTab === index
                                                                            ? 'white'
                                                                            : 'black'
                                                                }}
                                                            >
                                                                {label?.time}
                                                            </Box>
                                                        </Box>
                                                    }
                                                    sx={{
                                                        color: selectedTab === index ? 'white !important' : 'none',
                                                        fontStyle: 'normal',
                                                        fontWeight: 600,
                                                        color: 'white',
                                                        margin: '5px',
                                                        minWidth: 'auto',
                                                        paddingLeft: 1,
                                                        paddingRight: 1,
                                                        marginRight: 1,
                                                        color: 'black',
                                                        borderRadius: 2,
                                                        background:
                                                            isValidateClicked && hasError
                                                                ? '#FF3131'
                                                                : selectedTab === index
                                                                ? '#0E7AF0 !important'
                                                                : 'none'
                                                    }}
                                                />
                                            );
                                        })}
                                    </Tabs>
                                </Box>

                                <Box my={2}>
                                    <Typography
                                        my={1}
                                        sx={{
                                            color: '#919191',
                                            fontSize: '10px',
                                            fontStyle: 'normal',
                                            fontWeight: '600',
                                            lineHeight: 'normal'
                                        }}
                                    >
                                        Form Completed:{' '}
                                        <span style={{ color: '#1AA90D' }}>
                                            {progress <= 0 ? Math.round(myProgress) : Math.round(progress)}% complete
                                        </span>
                                    </Typography>

                                    <LinearProgress
                                        variant="determinate"
                                        value={progress <= 0 ? myProgress : progress}
                                        sx={{
                                            height: 6,
                                            borderRadius: 5,
                                            backgroundColor: '#e0e0df',
                                            '& .MuiLinearProgress-bar': {
                                                borderRadius: 5,
                                                backgroundColor: '#4caf50' // Green color for progress
                                            }
                                        }}
                                    />
                                </Box>

                                <Box sx={{ mt: '20px' }}>
                                    {selectedTab === 0 && (
                                        <Listing
                                            inputFocusRef={inputFocusRef}
                                            role={role}
                                            errors={errors}
                                            handleSubmit={handleSubmit}
                                            handleChange={customHandleChange}
                                            handleBlur={customHandleBlur}
                                            isSubmitting={isSubmitting}
                                            values={values}
                                            touched={touched}
                                            setFieldValue={setFieldValue}
                                            unitNumber={singleListing?.locationInformation?.unit}
                                            setDataSaved={() => {
                                                setIsDataSaved(true);
                                            }}
                                        />
                                    )}

                                    {selectedTab === 1 && (
                                        <General
                                            role={role}
                                            errors={errors}
                                            handleSubmit={handleSubmit}
                                            handleChange={customHandleChange}
                                            handleBlur={customHandleBlur}
                                            isSubmitting={isSubmitting}
                                            values={values}
                                            touched={touched}
                                            setFieldValue={setFieldValue}
                                            propertyContacts={propertyContacts}
                                            handleRegionalChange={(e) => {
                                                // setRmSelected(e);
                                                setFieldValue('apartmentAccess', []);
                                            }}
                                        />
                                    )}

                                    {selectedTab === 2 && (
                                        <AdditionalInfo
                                            errors={errors}
                                            handleSubmit={handleSubmit}
                                            handleChange={customHandleChange}
                                            handleBlur={customHandleBlur}
                                            isSubmitting={isSubmitting}
                                            values={values}
                                            touched={touched}
                                            setFieldValue={setFieldValue}
                                        />
                                    )}

                                    {selectedTab === 3 && (
                                        <RoomsInfo
                                            errors={errors}
                                            handleSubmit={handleSubmit}
                                            handleChange={customHandleChange}
                                            handleBlur={customHandleBlur}
                                            isSubmitting={isSubmitting}
                                            values={values}
                                            touched={touched}
                                            setFieldValue={setFieldValue}
                                            dispatch={dispatch}
                                            deleteRoomListings={deleteRoomListings}
                                            isDuplicate={isDuplicate}
                                            id={id}
                                            openSnackbar={openSnackbar}
                                            singleListing={singleListing}
                                            role={role}
                                            deleteGreenEnergyBuildingListings={deleteGreenEnergyBuildingListings}
                                        />
                                    )}

                                    {selectedTab === 4 && (
                                        <DocumentsInfo
                                            errors={errors}
                                            handleSubmit={handleSubmit}
                                            handleChange={customHandleChange}
                                            handleBlur={customHandleBlur}
                                            isSubmitting={isSubmitting}
                                            values={values}
                                            touched={touched}
                                            setFieldValue={setFieldValue}
                                            role={role}
                                        />
                                    )}

                                    {selectedTab === 5 && (
                                        <HowToApply
                                            role={role}
                                            errors={errors}
                                            handleSubmit={handleSubmit}
                                            handleChange={customHandleChange}
                                            handleBlur={customHandleBlur}
                                            isSubmitting={isSubmitting}
                                            values={values}
                                            touched={touched}
                                            setFieldValue={setFieldValue}
                                            id={id}
                                        />
                                    )}

                                    {selectedTab === 6 && (
                                        <ShowingInformation
                                            role={role}
                                            errors={errors}
                                            handleSubmit={handleSubmit}
                                            handleChange={customHandleChange}
                                            handleBlur={customHandleBlur}
                                            isSubmitting={isSubmitting}
                                            values={values}
                                            touched={touched}
                                            setFieldValue={setFieldValue}
                                        />
                                    )}

                                    <Grid container spacing={gridSpacing} sx={{ mt: 1 }}>
                                        {selectedTab >= 1 && selectedTab <= 7 && (
                                            <Grid item xs={12} md={3}>
                                                <AnimateButton>
                                                    <LoadingButton
                                                        disableElevation
                                                        fullWidth
                                                        size="large"
                                                        type="button"
                                                        variant="outlined"
                                                        color="secondary"
                                                        onClick={() => {
                                                            setSelectedTab(selectedTab - 1);
                                                            window.scrollTo({
                                                                top: 0,
                                                                behavior: 'smooth'
                                                            });
                                                        }}
                                                        sx={{ display: 'flex', gap: 1 }}
                                                    >
                                                        <KeyboardBackspaceIcon />
                                                        Back
                                                    </LoadingButton>
                                                </AnimateButton>
                                            </Grid>
                                        )}

                                        {selectedTab < 6 && (
                                            <Grid item xs={12} md={3}>
                                                <AnimateButton>
                                                    <LoadingButton
                                                        disableElevation
                                                        fullWidth
                                                        size="large"
                                                        type="button"
                                                        variant="outlined"
                                                        color="secondary"
                                                        sx={{ display: 'flex', gap: 1 }}
                                                        onClick={() => handleSave(values, setErrors, setTouched, setStatus, setSubmitting)}
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                        >
                                                            <path
                                                                d="M20 7.423V18.385C20 18.845 19.846 19.2293 19.538 19.538C19.23 19.8467 18.8453 20.0007 18.384 20H5.616C5.15533 20 4.771 19.846 4.463 19.538C4.155 19.23 4.00067 18.8453 4 18.384V5.616C4 5.15533 4.15433 4.771 4.463 4.463C4.77167 4.155 5.156 4.00067 5.616 4H16.577L20 7.423ZM19 7.85L16.15 5H5.616C5.436 5 5.28833 5.05767 5.173 5.173C5.05767 5.28833 5 5.436 5 5.616V18.385C5 18.5643 5.05767 18.7117 5.173 18.827C5.28833 18.9423 5.436 19 5.616 19H18.385C18.5643 19 18.7117 18.9423 18.827 18.827C18.9423 18.7117 19 18.564 19 18.384V7.85ZM12 16.538C12.5513 16.538 13.0227 16.3427 13.414 15.952C13.8053 15.5613 14.0007 15.09 14 14.538C13.9993 13.986 13.8037 13.515 13.413 13.125C13.0223 12.735 12.5513 12.5397 12 12.539C11.4487 12.5383 10.9777 12.7337 10.587 13.125C10.1963 13.5163 10.0007 13.9873 10 14.538C9.99933 15.0887 10.195 15.56 10.587 15.952C10.979 16.344 11.45 16.5393 12 16.538ZM6.77 9.77H14.192V6.77H6.77V9.77ZM5 7.85V19V5V7.85Z"
                                                                fill="black"
                                                            />
                                                        </svg>
                                                        Save & Next
                                                    </LoadingButton>
                                                </AnimateButton>
                                            </Grid>
                                        )}

                                        {selectedTab < 7 && (
                                            <Grid item xs={12} md={3}>
                                                <AnimateButton>
                                                    <LoadingButton
                                                        disableElevation
                                                        fullWidth
                                                        size="large"
                                                        type="submit"
                                                        variant="outlined"
                                                        color="secondary"
                                                        loading={isSubmitting}
                                                        onClick={async () => {
                                                            setIsValidateClicked(true);
                                                            handleSubmit();
                                                        }}
                                                        sx={{ display: 'flex', gap: 1 }}
                                                    >
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="24"
                                                            height="24"
                                                            viewBox="0 0 24 24"
                                                            fill="none"
                                                        >
                                                            <path
                                                                d="M4.125 13.125L9.375 18.375L19.875 7.125"
                                                                stroke="black"
                                                                stroke-width="1.5"
                                                                stroke-linecap="round"
                                                                stroke-linejoin="round"
                                                            />
                                                        </svg>
                                                        {getButtonLabel(selectedTab, id)}
                                                    </LoadingButton>
                                                </AnimateButton>
                                            </Grid>
                                        )}

                                        {selectedTab < 6 && (
                                            <Grid item xs={12} md={3}>
                                                <AnimateButton>
                                                    <LoadingButton
                                                        disableElevation
                                                        fullWidth
                                                        size="large"
                                                        type="button"
                                                        variant="contained"
                                                        color="secondary"
                                                        onClick={() =>
                                                            handleSave(values, setErrors, setTouched, setStatus, setSubmitting, true)
                                                        }
                                                    >
                                                        Submit
                                                    </LoadingButton>
                                                </AnimateButton>
                                            </Grid>
                                        )}

                                        {selectedTab === 6 && <FormError errors={errors} />}
                                    </Grid>
                                </Box>
                            </>
                        );
                    }}
                </Formik>
            </Box>
        </>
    );
};

export default CreateListingNew;
